export enum CountryCodes {
  Israel = 'IL',
}
